import {createApiPath, createFetchAndCall} from './fetch/fetchServices';
import * as apiConstants from '../constants/apiConstants';

class FileUpload {
  static uploadFile(fileContents, fileName) {
    let fileUploadApi = createApiPath(apiConstants.uploadFile);
    let headers = {
      'accept': 'application/json',
      'content-type': 'application/json',
      'Cache-Control': 'no-cache',
      'x-file-name': fileName
    };

    let options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({data: btoa(fileContents)})
    };
    return createFetchAndCall(fileUploadApi, options);
  }

  static uploadCaseDataFile(fileContents, fileName) {
    let fileUploadApi = createApiPath(apiConstants.uploadCaseDataFile);
    let headers = {
      'accept': 'application/json',
      'content-type': 'application/json',
      'Cache-Control': 'no-cache',
      'x-file-name': fileName
    };

    let options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({data: btoa(fileContents)})
    };
    return createFetchAndCall(fileUploadApi, options);
  }
}

export default FileUpload;



/** WEBPACK FOOTER **
 ** ./src/api/fileUploadApi.js
 **/